import { colors } from "@/utils/const";
import CustomText from "./text";
import { useI18n } from "@/i18n/I18nProvider";
import Box from "@mui/material/Box";
import { formatNumber } from "@/utils/general-functions";

export default function AmountCard({
  text = "amount",
  value = "000",
  color = "#FF7701",
  loading = false,
}) {
  const { t } = useI18n();

  return (
    <Box
      sx={{
        border: "1px solid rgba(255, 255, 255, 0.10)",
        borderRadius: "10px",
        padding: "12px",
        background:
          "linear-gradient(180deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.10) 100%)",
        mt: 2,
      }}
    >
      {!loading && (
        <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 1 }}>
          <Box
            sx={{
              width: "5px",
              height: "5px",
              borderRadius: "2px",
              background: color,
            }}
          />
          <CustomText
            variant="p"
            sx={{ color: colors.navy }}
            text={text}
            type="xxs"
            customStyle={{ color: "#fff" }}
          />
        </Box>
      )}

      {loading ? (
        <div className="box-loading">
          <span className="loader"></span>
        </div>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <CustomText
            type="l"
            customStyle={{
              color: "#fff",
              fontWeight: "bold",
              fontSize: { xs: "24px", md: "28px" },
            }}
            text={value > 0 ? `${formatNumber(value)} ` : "--"}
          />

          <CustomText
            type="md"
            customStyle={{ color: "rgba(255, 255, 255, 0.6)" }}
            text={t.calc.egyptianPound}
          />
        </Box>
      )}
    </Box>
  );
}
